import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Shared/Layout";
import { get } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";

const imageurl = process.env.REACT_APP_IMAGE_BASE_URL

const SubCategory = () => {
    const [loading, setLoading] = useState(false);
    const productCategoryId = localStorage.getItem('productCategoryId');
    const [subCategoryData, setSubCategoryData] = useState([]);
    const navigate = useNavigate();

    const GetProductDetailById = useCallback(async () => {
        setLoading(true);
        try {

            let url = `${API_URL?.GetProductSubCategoryByCategoryId}?pProductCategoryId=${productCategoryId}`;

            const response = await get(url);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product => product.isDisplay);
                setSubCategoryData(filteredData);
            }
        } catch (error) {
            setSubCategoryData([]);
        } finally {
            setLoading(false);
        }
    }, [productCategoryId]);

    useEffect(() => {
        GetProductDetailById();
    }, [GetProductDetailById]);

    const onProductBySubCategoryId = (item) => {
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);
        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
    };

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    return (
        <Layout>
            <section className="same_space layout_main">
                <div className="container">
                    <div className="row">
                        {subCategoryData?.map((item, index) => (
                            <div key={index} className="slider-item col-xl-3 col-sm-4 col-6 mb-4 curser-pointer" onClick={() => onProductBySubCategoryId(item)}>
                                <div className="subcategory_wrqapper">
                                    <img
                                        src={`${imageurl}${item?.imgPath || './images/sercal-img.png'}`}
                                        className="w-100"
                                        alt=""
                                    />
                                    <div className="subcategory_name">
                                        <p className="data-title mb-0">{item?.displayName}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Layout >
    )
}

export default SubCategory;